import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {rankDescriptionById} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {withProps} from '/util/selector.util';

import RankName from './RankName';

export default connect(
  createStructuredSelector({
    name: withProps({coachId: userId})(rankDescriptionById),
  }),
)(RankName);
